// extracted by mini-css-extract-plugin
module.exports =  {"moreInfoArea":"moreInfoArea__F0-i8","moreInfo":"moreInfo__cogA0","advanceInput":"advanceInput__SMdm4","isThresholdFreebieTip":"isThresholdFreebieTip__EF6Xz"};